package pages.home

import kotlinx.browser.document
import kotlinx.html.TagConsumer
import kotlinx.html.div
import kotlinx.html.style
import org.w3c.dom.HTMLElement

inline fun TagConsumer<HTMLElement>.homePage() {
   document.querySelector("div.main")?.remove()
   div("main") {
      style = """

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  """
      cliJokeImg();
      bio()
   }
}